import { Spin, Popover } from 'antd';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'react-redux';
import { formatDate } from '../../../Utils/dateFormat';
import Spinner from '../../CustomComponents/Spinner';
import {
  CommentButton,
  CommentDivTitleStyle,
  PopoverGlobalStyle
} from '../JobList/styledComponents';
import CommentIcon from '../../../Assets/Icons/CommentIcon';
import {
  JobTableContainer,
  JobTable,
  JobTableHeadingRow,
  JobRow,
  StyledColumn,
  InformationTitle,
  InformationText,
  JobStatusDiv
} from './styledComponents';

const JobDetails = ({
  loading,
  jobData,
  getSessionJobDetails,
  hasMore,
  scrollLoading,
  sessionId,
  selectedTab,
  hideComment
}) => {
  const [theme] = useSelector(state => [state.themeReducer]);

  const spanLength = (tab, userType) => {
    return tab === 1 ? 6 : userType ? 4 : 5;
  };

  // When Comment column is hidden, redistribute its 2 spans to Start/End Time.
  const timeSpan = tab => (tab === 1 && hideComment ? 4 : 3);

  return (
    <JobTableContainer>
      {loading ? (
        <Spinner height={'50vh'} />
      ) : (
        <>
          <JobTableHeadingRow>
            <StyledColumn span={spanLength(selectedTab)}>
              <InformationTitle color={theme['@text-color']}>
                {selectedTab === 1 ? 'Job Id' : 'User Name'}
              </InformationTitle>
            </StyledColumn>
            {selectedTab === 2 && (
              <StyledColumn span={spanLength(selectedTab, true)}>
                <InformationTitle color={theme['@text-color']}>
                  User Type
                </InformationTitle>
              </StyledColumn>
            )}
            <StyledColumn span={timeSpan(selectedTab)}>
              <InformationTitle color={theme['@text-color']}>
                Start Time
              </InformationTitle>
            </StyledColumn>
            <StyledColumn span={timeSpan(selectedTab)}>
              <InformationTitle color={theme['@text-color']}>
                End Time
              </InformationTitle>
            </StyledColumn>
            <StyledColumn span={spanLength(selectedTab)}>
              <InformationTitle color={theme['@text-color']}>
                Action
              </InformationTitle>
            </StyledColumn>
            {!hideComment && (
              <StyledColumn span={2}>
                <InformationTitle color={theme['@text-color']}>
                  Comment
                </InformationTitle>
              </StyledColumn>
            )}
          </JobTableHeadingRow>
          <JobTable key={sessionId}>
            <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              loadMore={getSessionJobDetails}
              hasMore={!scrollLoading && hasMore}
              useWindow={false}
            >
              {jobData.map(job => {
                return (
                  <JobRow>
                    <StyledColumn span={spanLength(selectedTab)}>
                      <InformationText name={true}>
                        {job.jobId || job.userName}
                      </InformationText>
                    </StyledColumn>
                    {selectedTab === 2 && (
                      <StyledColumn span={spanLength(selectedTab, true)}>
                        <InformationText name={true}>
                          {job.userType}
                        </InformationText>
                      </StyledColumn>
                    )}
                    <StyledColumn span={timeSpan(selectedTab)}>
                      <InformationText>
                        {job.startTime ? formatDate(job.endTime, 'N/A') : 'N/A'}
                      </InformationText>
                    </StyledColumn>
                    <StyledColumn span={timeSpan(selectedTab)}>
                      <InformationText>
                        {job.endTime ? formatDate(job.endTime, 'N/A') : 'N/A'}
                      </InformationText>
                    </StyledColumn>
                    <StyledColumn span={spanLength(selectedTab)}>
                      <JobStatusDiv>{job.status || job.action}</JobStatusDiv>
                    </StyledColumn>
                    {!hideComment && job.comment && (
                      <StyledColumn span={2}>
                        <Popover
                          title={
                            <CommentDivTitleStyle>Comment</CommentDivTitleStyle>
                          }
                          content={<div>{job.comment}</div>}
                        >
                          <PopoverGlobalStyle />
                          <CommentButton
                            icon={<CommentIcon />}
                            shape='circle'
                            style={{ marginLeft: 4 }}
                          />
                        </Popover>
                      </StyledColumn>
                    )}
                  </JobRow>
                );
              })}
              {scrollLoading && <Spin size='small' />}
            </InfiniteScroll>
          </JobTable>
        </>
      )}
    </JobTableContainer>
  );
};

export default JobDetails;
